import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { trackButtonClick } from '../api/tracking';
import PageRenderer from '../pages/PageRenderer';
import CmsPreviewPage from '../pages/CmsPreviewPage';

export default function App() {
  useEffect(() => {
    const onClick = (event: MouseEvent) => {
      if (event.target instanceof Element) trackButtonClick(event.target);
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  const isPreviewHost = window.location.hostname
    .toLowerCase()
    .startsWith('preview.');

  if (isPreviewHost) {
    return <CmsPreviewPage />;
  }

  return (
    <Routes>
      <Route path="*" element={<PageRenderer />} />
    </Routes>
  );
}
